export default {
  delete: 'Delete',
  edit: 'Modify',
  cancel: 'Cancel',
  clear: 'Clear',
  new: 'New',
  update: 'Update',
  undo: 'Undo',
  option: 'Option',
  details: 'Details',
  deleting: 'Deleting',
  createdAt: 'Created At',
  firstSeen: 'First Seen',
  lastActive: 'Last Active',
  'idle.title': 'Your session is about to expire',
  'idle.content': 'Resume the session now or logout',
  resume: 'Resume',
  name: 'Name',
  'success.reloading': 'Successful, reloading page',
  'fail.retry': 'Failed, please try again',
  tags: 'Tags',
  after: 'After',
  flow: 'Flow',
  text: 'Text',
  image: 'Image',
  video: 'Video',
  file: 'File',
  custom: 'Custom',
  input: 'Input',
  quickReplies: 'Quick Replies',
  ctaUrl: 'CTA Url',
  button: 'Button',
  question: 'Question',
  fieldRequired: 'This field is required',
  entity: 'Entity',
  active: 'Active',
  inactive: 'Inactive',
  deleted: 'Deleted',
  next: 'Next',
  category: 'Category',
  portalUser: 'Portal User',
  role: 'Role',
  admin: 'Admin',
  user: 'User',
  username: 'Username',
  email: 'Email',
  firstName: 'First Name',
  lastName: 'Last Name',
  fullName: 'Full Name',
  resetPassword: 'Reset Password',
  'resetPassword.emailSent': 'Password reset email has been sent to the user',
  'resetPassword.confirm.title': 'Reset password for this user?',
  'resetPassword.confirm.content': 'A password reset email will be sent to {username} ({email})',
  'resetPassword.emailFailed': 'Failed to send reset email, please try again',
  'resetPassword.tokenExpired': 'Reset Password Token expired',
  oldPassword: 'Current Password',
  newPassword: 'New Password',
  'password.characterNotMet':
    'Password must contain at least one letter, one number, and one special character',
  confirmPassword: 'Confirm Password',
  'confirmPassword.mismatch': 'The two passwords that you entered do not match!',
  unlock: 'Unlock',
  'portalUser.unlock.title': 'Unlock the user',
  'portalUser.unlock.content':
    '{username} ({email}) - A password reset email will be sent to the user if applicable',
  'portalUser.userPasswordModal.title': 'User Password Modal',
  logout: 'Log Out',
  dormant: 'Dormant',
  'portalUser.dormant.title': 'Are you sure to dormant this user?',
  'portalUser.dormant.content':
    '{username} ({email}) - Please note that after dormancy, this user cannot access this portal any more',
  reactivate: 'Reactivate',
  'portalUser.reactivate.title': 'Are you sure to reactivate this user?',
  'portalUser.reactivate.content':
    '{username} ({email}) - Please note that after reactivating, this user will gain access this portal immediately',
  'portalUser.delete.title': 'Are you sure to delete this user?',
  'portalUser.delete.content':
    '{username} ({email}) - Please note that after deletion, this user cannot access this portal any more. Personal data will be erased, alternatively, you may dormant the user.',
  'portalUser.delete.undo': '{username} ({email}) deleted',
  'portalUser.emailChange.title': 'Change user email?',
  'portalUser.emailChange.content':
    'The email will be updated to {newEmail} and a password reset email will be sent to that address. The user will be logged out and must set a new password to log in again.',
  'portalUser.emailChange.noEmail.content':
    'The email will be updated to {newEmail}. Email service is not configured for this organisation, so a new password will be generated and shown to you to share with the user.',
  platform: 'Platform',
  notes: 'Notes',
  'pages.review.title': 'Review',
  'pages.review.description':
    'Generate structured reviews of one or more documents based on your Question Lists',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.file.placeholder.type': 'Type',
  'pages.file.placeholder.people': 'Creator',
  'pages.file.placeholder.search': 'Search file or folder',
  'pages.file.placeholder.editfile': 'Modify File Name',
  'pages.file.pdf': 'PDF',
  'pages.file.document': 'Document',
  'pages.file.msg': 'MSG',
  'pages.file.eml': 'EML',
  'pages.file.txt': 'Text',
  'pages.file.md': 'Markdown',
  'pages.file.excel': 'Excel',
  'pages.file.powerpoint': 'PowerPoint',
  'pages.file.uploading': 'Uploading',
  'pages.file.clickDragFile': 'Click or drag files here to upload',
  'pages.file.createfolder': 'Create Folder',
  'pages.file.uploadFiles': 'Upload Files',
  'pages.file.upload.time': 'Uploaded Time:',
  'pages.file.created.time': 'Created Time:',
  'pages.file.favorites': 'My Favorites',
  'pages.file.history': 'Revision History',
  'pages.file.success': 'Created successfully',
  'pages.file.filePreview': 'File Preview',
  'pages.file.prompt.uploadFiled': 'Failed to upload',
  'pages.file.prompt.network': 'Network Error',
  'pages.file.prompt.fetchFiles': 'Failed to obtain file list information',
  'pages.file.prompt.createGroup': 'Failed to create group',
  'pages.file.prompt.createFolderSucc': 'Folder created successfully',
  'pages.file.prompt.createFolderFail': 'Failed to create folder',
  'pages.file.prompt.updateSucc': 'Updated successfully',
  'pages.file.prompt.updateFail': 'Failed to update',
  'pages.file.prompt.addFavoriteFail': 'Failed to added',
  'pages.file.prompt.noPermission': 'You do not have permission to modify this session',
  'pages.file.prompt.duplicateName': 'Duplicate session name',
  'pages.file.prompt.notFound': 'Unable to find session',
  'pages.file.prompt.deleteGroupSuc': 'Successfully deleted',
  'pages.file.prompt.uploadFiles': 'file ready to be uploaded',
  'pages.file.prompt.downloadSucc': 'Download successfully',
  'pages.file.prompt.downloadFail': 'Failed to download',
  'pages.file.prompt.authFail': 'Authorization token is missing.',
  'pages.file.prompt.moveSucc': 'File moved successfully',
  'pages.chat.newWithUploadedDocument': 'Start a new Chat with documents',
  'pages.chat.editSessionName': 'Modify Session Name',
  'pages.chat.placeholder.inputSessionName': 'Enter new session name',
  'pages.chat.placeholder': 'Write something you want to ask...',
  'pages.chat.word': '/10000 characters',
  'pages.chat.rateMessage.successfulLike': 'Successfully liked the message',
  'pages.chat.rateMessage.successfulDislike': 'Successfully disliked the message',
  'pages.chat.actions.like': 'Good response',
  'pages.chat.actions.dislike': 'Bad response',
  'pages.chat.rateMessage.error': 'Failed to rate the message',
  'pages.chat.selectContext.setFilePriority.success': 'Successfully updated File Priority',
  'pages.chat.selectContext.setFilePriority.error': 'Error on updating File Priority',
  'pages.chat.selectContext.toolTipDefault':
    'By default, the bot will have access to all files that you have access to.',
  'pages.chat.rerank':
    'Sorts the search results a second time before returning the results. This may improve the quality of the results but makes the search significantly slower.',
  'pages.chat.selectContext.tootlTipRestrict':
    'You may use this menu to restrict the files made available to the model.',
  'pages.chat.hybridSearchAlphaTooltip':
    'The search ratio controls the balance between semantic and keyword search. Low values favour keyword search whilst high values favour semantic search.',
  'pages.chat.favoriteFileWeight':
    'This weight artificially increases the search ranking of favourited files.',
  'pages.dashboard.realTimeUsersTitleTooltip':
    'Number of users who are currently interacting with the bot or have interacted with the bot within the last 5 minutes.',
  'pages.dashboard.activeUsersTitleTooltip':
    'Number of users who have interacted with the bot during the selected period.',
  'pages.dashboard.newUsersTitleTooltip':
    'Number of users who interacted with the bot for the first time ever during the selected period.',
  'pages.dashboard.promptTokensTitleTooltip':
    'Number of input tokens processed during the selected period.',
  'pages.dashboard.completionTokensTitleTooltip':
    'Number of output tokens generated during the selected period.',
  'pages.dashboard.userMessagesTitleTooltip':
    'Number of messages sent by users during the selected period.',
  'pages.dashboard.storyboardsTitleTooltip':
    'Number of users messages handled by pre-built chatbot storyboards within the selected period.',
  'pages.dashboard.botMessagesTitleTooltip':
    'Number of messages sent to users by the bot within the selected period.',
  'pages.dashboard.broadcastsTitleTooltip':
    'Number of messages sent to users initiated by the bot through the Broadcast function within the selected period.',
  'pages.dashboard.repliesTitleTooltip':
    'Number of messages sent to users in response to user messages within the selected period.',
  'pages.dashboard.messageExchangesTitleTooltip':
    'Number of messages exchanges by users and the bot within the selected period.',
  'pages.dashboard.broadcastTitleTooltip':
    'Number of broadcasts initiated by the bot within the selected period.',
  'pages.dashboard.outReachTitleTooltip':
    'Sum of the number of recipients of all broadcasts within the selected period.',
  'pages.chat.stopGenerating': 'Stopped generating.',
  'pages.chat.stopGenerating.error': 'Failed to stop generating.',
  'pages.app.timeline': 'Timeline',
  'pages.app.guided_summary': 'Guided Summary',
  'pages.app.standard_info': 'Quick Info',
  'pages.app.addCustomFieldsTitle': 'Add custom fields to extract for each event',
  'pages.app.addCustomStepButton': 'Add Custom Step',
  'pages.app.addFieldButton': 'Add Field',
  'pages.app.addFromLibraryButton': 'Add from Library',
  'pages.app.addToMattersButton': 'Add to Matters',
  'pages.app.analysisType.agenticResearch.description':
    'Explores the selected documents and uploaded files, then synthesises a comprehensive answer with citations.',
  'pages.app.analysisType.agenticResearch.title': 'Agentic Research',
  'pages.app.analysisType.comparison.description':
    'Compares two documents and gives a report describing the differences. You may provide a prompt to target the comparison.',
  'pages.app.analysisType.comparison.title': 'Comparison',
  'pages.app.analysisType.contractDeadlines.description':
    "List all deadlines, important dates and durations found in the contract/document. It help to  give details of the client (such as 'clients are a Singapore bank which specialises in e-banking services')",
  'pages.app.analysisType.contractDeadlines.title': 'Extract Deadlines',
  'pages.app.analysisType.executiveSummary.description':
    'Provides a concise executive summary of key advice, issues, risks, and actions.',
  'pages.app.analysisType.executiveSummary.title': 'Executive Summary',
  'pages.app.analysisType.gartnerReport.description':
    'Provides an in-depth industry report with forecasts and recommendations.',
  'pages.app.analysisType.gartnerReport.title': 'Gartner-style Report',
  'pages.app.analysisType.guidedSummary.description':
    'Provides a detailed summary of a single document guided by a prompt.',
  'pages.app.analysisType.multiStepPrompt.description':
    "Execute multiple prompts sequentially, building on each step's output.",
  'pages.app.analysisType.multiStepPrompt.title': 'Multi-Step Prompt',
  'pages.app.analysisType.scopeOfWork.description':
    'Upload or select a client email, letter or RFP with a request for assistance or services. In the "Prompt", it helps to  give details of the client (such as \'clients are a Singapore bank which specialises in e-banking services\')',
  'pages.app.analysisType.scopeOfWork.title': 'Scope of Work Summary',
  'pages.app.analysisType.standardInfo.description':
    'Provides a concise summary, a list of people and entities of interest and a short timeline of events. You may provide up to 100 documents.',
  'pages.app.analysisType.timeline.description':
    'Provides a detailed timeline of events over up to 100 documents.',
  'pages.app.analyzingFiles': 'Analyzing files...',
  'pages.app.applicablePartiesColumnTitle': 'Applicable Parties',
  'pages.app.appsInstructions':
    'Select several files to work with and then choose a type of analysis from the list below. Requests take around 1-5 minutes to process.',
  'pages.app.appsList.agenticResearch.description':
    'Explores the selected documents and uploaded files, then synthesises a comprehensive answer with citations.',
  'pages.app.appsList.contractDeadlines.description':
    'List all deadlines, important dates and durations found in the contract/document.',
  'pages.app.appsList.executiveSummary.description':
    'High-level overview of key points, findings, and recommendations for leadership',
  'pages.app.appsList.gartnerReport.description':
    'In-depth industry analysis using confident and objective research methodology',
  'pages.app.appsList.guidedSummary.description':
    'Provides a detailed summary of a single document guided by a prompt',
  'pages.app.appsList.multiStepPrompt.description':
    "Execute multiple prompts sequentially, building on each step's output",
  'pages.app.appsList.scopeOfWork.description':
    'Upload or select a client email, letter or RFP with a request for assistance or services.',
  'pages.app.appsList.standardInfo.description':
    'Provides a concise summary, list of people and entities, and short timeline',
  'pages.app.appsList.timeline.description':
    'Provides a detailed timeline of events over up to 100 documents',
  'pages.app.appsTitle': 'Apps',
  'pages.app.backgroundColumnTitle': 'Background',
  'pages.app.buildMultiStepPromptTitle': 'Build your multi-step prompt',
  'pages.app.clauseColumnTitle': 'Clause',
  'pages.app.clientDetailsPlaceholder': 'Name and brief details of the client',
  'pages.app.clientInformationTitle': 'Client Information',
  'pages.app.clientLabel': 'Client',
  'pages.app.collapseAllPrompts': 'Collapse all prompts',
  'pages.app.collapsePrompt': 'Collapse prompt',
  'pages.app.compilingFinalSummary': 'Compiling final summary...',
  'pages.app.complexityLabel': 'Complexity',
  'pages.app.configNameLabel': 'Config Name',
  'pages.app.configurationDeletedSuccess': 'Configuration deleted',
  'pages.app.configurationSavedSuccess': 'Configuration saved successfully',
  'pages.app.configurationUpdatedSuccess': 'Configuration updated successfully',
  'pages.app.contactLabel': 'Contact',
  'pages.app.counterpartyLabel': 'Counterparty',
  'pages.app.dateReferenceColumnTitle': 'Date/Reference',
  'pages.app.deadlinesSectionTitle': 'Deadlines',
  'pages.app.deleteConfigConfirmTitle': 'Are you sure you want to delete this configuration?',
  'pages.app.deleteStepTooltip': 'Delete step',
  'pages.app.detailsColumnTitle': 'Details',
  'pages.app.doneCount': 'Done ({completed}/{total})',
  'pages.app.dragHereToUpload': 'Drag here to upload',
  'pages.app.dragStepTooltip': 'Drag step',
  'pages.app.dropZoneForNamedStep': 'Drop zone for {stepName}',
  'pages.app.dropZoneForStepNumber': 'Drop zone for step {stepNumber}',
  'pages.app.durationColumnTitle': 'Duration',
  'pages.app.enterConfigNamePlaceholder': 'Enter config name',
  'pages.app.enterDescriptionPlaceholder': 'Enter description',
  'pages.app.entitiesColumnTitle': 'Entities',
  'pages.app.expandAllPrompts': 'Expand all prompts',
  'pages.app.expandPrompt': 'Expand prompt',
  'pages.app.extendPromptTabLabel': 'Extend Prompt',
  'pages.app.extraFieldDescriptionPlaceholder':
    'Description (e.g. Extract the monetary value mentioned)',
  'pages.app.extraFieldKeyPlaceholder': 'Key (e.g. Budget)',
  'pages.app.extractColumnTitle': 'Extract',
  'pages.app.extractDeadlinesModalDescription':
    "List all deadlines, important dates and durations found in the contract/document. It help to give details of the client (such as 'clients are a Singapore bank which specialises in e-banking services')",
  'pages.app.fileCountLabel': '{count} File(s)',
  'pages.app.filesCompleteCount': '{completed}/{total} files complete',
  'pages.app.hardDeadlineColumnTitle': 'Hard Deadline',
  'pages.app.inProgressSuffix': ' (in progress)',
  'pages.app.keyDatesDeadlinesTitle': 'Key Dates & Deadlines',
  'pages.app.loadSavedConfigPlaceholder': 'Load saved config',
  'pages.app.loadingDocumentTip': 'Loading document...',
  'pages.app.mattersUpdatedSuccess': 'Matters updated successfully',
  'pages.app.moveStepDownTooltip': 'Move down',
  'pages.app.moveStepUpTooltip': 'Move up',
  'pages.app.newAnalysisModesDescription':
    'We have introduced two new powerful analysis modes to help you get more value from your contracts.',
  'pages.app.newAnalysisModesTitle': 'New Analysis Modes',
  'pages.app.newFieldDefaultKey': 'Field {number}',
  'pages.app.newSessionLabel': 'New Session',
  'pages.app.newStepDefaultName': 'New Step',
  'pages.app.noSourceDocumentsDescription': 'No source documents',
  'pages.app.noTimelineItemsExtracted': 'No timeline items extracted.',
  'pages.app.overallTabLabel': 'Overall',
  'pages.app.overviewSectionTitle': 'Overview',
  'pages.app.partiesSectionTitle': 'Parties',
  'pages.app.peopleEntitiesInvolvedLabel': 'People / Entities Involved',
  'pages.app.periodsDurationsTitle': 'Periods & Durations',
  'pages.app.pleaseEnterPlaceholder': 'Please enter',
  'pages.app.processingNextStep': 'Processing next step...',
  'pages.app.promptForStepPlaceholder': 'Prompt for this step',
  'pages.app.promptLabelWithValue': 'Prompt: {prompt}',
  'pages.app.provideDetailsTabLabel': 'Provide details',
  'pages.app.provideDocumentsTabLabel': 'Provide documents',
  'pages.app.providePromptsTabLabel': 'Provide prompts',
  'pages.app.provisionColumnTitle': 'Provision',
  'pages.app.publishAudienceGroupsLabel': 'Groups',
  'pages.app.publishAudienceLabel': 'Audience',
  'pages.app.publishAudienceOptionFirmWide': 'Firm-wide',
  'pages.app.publishAudienceOptionGroup': 'Group',
  'pages.app.publishAudienceOptionPublic': 'Public',
  'pages.app.publishButton': 'Publish',
  'pages.app.publishConfigTitle': 'Publish Config',
  'pages.app.publishFirmWideNotice':
    'This config will be shared with everyone in your organisation. A request will be sent to the org admin for approval.',
  'pages.app.publishPublicNotice':
    'This config will be visible to all users. A request will be sent to the super admin for approval.',
  'pages.app.publishRequestSubmitted': 'Publish request submitted — awaiting admin approval',
  'pages.app.publishedToGroup': 'Published to group',
  'pages.app.readingDocumentName': 'Reading {name}',
  'pages.app.restrictionColumnTitle': 'Restriction',
  'pages.app.restrictiveCovenantsTitle': 'Restrictive Covenants',
  'pages.app.reuseButton': 'Re-use',
  'pages.app.runAppButton': 'Run App',
  'pages.app.sanitizedCheckingDocuments': 'Checking documents…',
  'pages.app.sanitizedSearchingDocuments': 'Searching documents…',
  'pages.app.sanitizedWorkingThroughDocuments': 'Working through documents…',
  'pages.app.saveConfigButton': 'Save Config',
  'pages.app.saveConfigurationTitle': 'Save Configuration',
  'pages.app.scopeOfWorkModalDescription':
    'Upload or select a client email, letter or RFP with a request for assistance or services. In the "Prompt", it helps to give details of the client (such as \'clients are a Singapore bank which specialises in e-banking services\')',
  'pages.app.searchMattersPlaceholder': 'Search matters...',
  'pages.app.searchPromptsPlaceholder': 'Search prompts...',
  'pages.app.selectAtLeastOneGroupError': 'Select at least one group',
  'pages.app.selectDocumentsStepTitle': '1. Select the document(s) you wish to analyse',
  'pages.app.selectMattersLabel': 'Select matter(s):',
  'pages.app.sharedConfigLabel': '{name} (shared)',
  'pages.app.sourcesColumnTitle': 'Sources',
  'pages.app.specialRequestsSectionTitle': 'Special Requests',
  'pages.app.specificInformationStepTitle': '2. Specific information (optional)',
  'pages.app.stepNamePlaceholder': 'Step Name (e.g. Extract Entities)',
  'pages.app.stepNumberLabel': 'Step {number}',
  'pages.app.subagentLabel': 'Subagent {number}',
  'pages.app.subjectLabel': 'Subject',
  'pages.app.summaryLabel': 'Summary',
  'pages.app.timelineFieldsDescription':
    'Define additional columns you want to see in the timeline. For each field, provide a key (column header) and a description of what information to extract.',
  'pages.app.tool.checkingDocuments': 'Checking documents',
  'pages.app.tool.readingDocument': 'Reading document',
  'pages.app.tool.searchingDocuments': 'Searching documents',
  'pages.app.tool.workingWithName': 'Working ({name})',
  'pages.app.tool.writingReport': 'Writing report',
  'pages.app.untitledSession': '(Untitled)',
  'pages.app.updateConfigButton': 'Update',
  'pages.app.updateConfigurationTitle': 'Update Configuration',
  'pages.app.updateMattersFailed': 'Failed to update matters',
  'pages.app.uploadOrSelectFilesError': 'Please upload files or select existing files',
  'pages.app.urgencyColumnTitle': 'Urgency',
  'pages.app.useAnotherAppButton': 'Use another App',
  'pages.app.whatsNew': "What's New",
  'pages.app.workingEllipsis': 'Working…',
  'pages.app.workingThroughDocumentsCount': 'Working through documents ({completed}/{total})',
  'pages.login.microsoftSSO': 'Sign in with Microsoft',
  'pages.login.loading': 'Loading...',
  'pages.login.redirectingToMS': 'Redirecting to Microsoft SSO...',
  'pages.loggedOut.title': 'Signed out',
  'pages.loggedOut.heading': 'You have been signed out',
  'pages.loggedOut.description':
    'You can close this window or return to the login page to sign in again.',
  'pages.loggedOut.return': 'Back to login',
  'pages.projectsHub.func.chat': 'Chat',
  'pages.projectsHub.func.scribe': 'Scribe',
  'pages.projectsHub.func.apps': 'Apps',
  'pages.projectsHub.func.review': 'Review',
  'pages.projectsHub.func.sideBySide': 'Side by Side',
  'pages.projectsHub.func.comparison': 'Comparison',
  'pages.projectsHub.func.translation': 'Translation',
  'pages.projectsHub.func.template': 'Custom Output',
  'pages.projectsHub.func.quote': 'Quote',
  'pages.projectsHub.untitledSession': 'Untitled',
  'pages.projectsHub.untitledFileLabel': '(Untitled)',
  'pages.projectsHub.errors.loadDataFailed': 'Failed to load data',
  'pages.projectsHub.subfolderCreated': 'Subfolder created',
  'pages.projectsHub.collectionCreated': 'Collection created',
  'pages.projectsHub.errors.createFailed': 'Failed to create',
  'pages.projectsHub.errors.updateFailed': 'Failed to update',
  'pages.projectsHub.deleteCollectionConfirm.title': 'Delete Collection',
  'pages.projectsHub.deleteCollectionConfirm.content': 'Delete "{name}"?',
  'pages.projectsHub.collectionDeleted': 'Deleted',
  'pages.projectsHub.errors.deleteFailed': 'Failed',
  'pages.projectsHub.sessionsAdded': '{count} session(s) added',
  'pages.projectsHub.errors.addSessionsFailed': 'Failed to add',
  'pages.projectsHub.sessionRemoved': 'Session removed',
  'pages.projectsHub.errors.removeSessionFailed': 'Failed to remove session',
  'pages.projectsHub.sessionsRemoved': '{count} session(s) removed',
  'pages.projectsHub.errors.removeSessionsFailed': 'Failed to remove sessions',
  'pages.projectsHub.fieldSaved': 'Saved',
  'pages.projectsHub.errors.saveFieldFailed': 'Failed to save',
  'pages.projectsHub.folderDeleted': 'Folder deleted',
  'pages.projectsHub.errors.deleteFolderFailed': 'Failed to delete folder',
  'pages.projectsHub.folderCreated': 'Folder created',
  'pages.projectsHub.errors.createFolderFailed': 'Failed to create folder',
  'pages.projectsHub.deleteFolderConfirm.description': 'Delete "{name}" and all its contents?',
  'pages.projectsHub.deleteSessionsConfirm.title': 'Delete Sessions',
  'pages.projectsHub.deleteSessionsConfirm.description':
    'Remove {count} session(s) from this collection?',
  'pages.projectsHub.removeSessionConfirm.title': 'Remove Session',
  'pages.projectsHub.removeSessionConfirm.description': 'Remove "{name}" from this collection?',
  'pages.projectsHub.sort.newestFirst': 'Newest first',
  'pages.projectsHub.sort.oldestFirst': 'Oldest first',
  'pages.projectsHub.sort.nameAsc': 'Name (A-Z)',
  'pages.projectsHub.sort.nameDesc': 'Name (Z-A)',
  'pages.projectsHub.doubleClickToOpen': 'Double-click to open',
  'pages.projectsHub.tidyUp': 'Tidy up',
  'pages.projectsHub.exit': 'Exit',
  'pages.projectsHub.manage': 'Manage',
  'pages.projectsHub.deleteSessionsButton': 'Delete ({count})',
  'pages.projectsHub.searchSessionsPlaceholder': 'Search sessions',
  'pages.projectsHub.emptyState.noFiles': 'No files',
  'pages.projectsHub.newFolderButton': 'New Folder',
  'pages.projectsHub.addSessionsButton': 'Add Sessions',
  'pages.projectsHub.folderInfoLabel': 'Folder Info',
  'pages.projectsHub.mattersHeading': 'Matters',
  'pages.projectsHub.mattersSubtitle':
    'Create collections and organise sessions from different functions in one workspace.',
  'pages.projectsHub.hubBreadcrumbLabel': 'Hub',
  'pages.projectsHub.deleteFolderButton': 'Delete Folder',
  'pages.projectsHub.itemsLabel': 'Items',
  'pages.projectsHub.selectSubfolderEmptyState': 'Select a subfolder to view details',
  'pages.projectsHub.selectFolderEmptyState': 'Select a folder to view details',
  'pages.projectsHub.noCollectionsMatch': 'No collections match your current filter.',
  'pages.projectsHub.noSessionsFoundForFunction': 'No {func} sessions found.',
  'pages.projectsHub.addSelectedSessionsButton':
    'Add {count, plural, =0 {selected} other {# session(s)}}',
  'pages.projectsHub.step1ChooseFunctionType': 'Step 1 — Choose a function type',
  'pages.projectsHub.selectFunctionPlaceholder': 'Select function',
  'pages.projectsHub.step2SelectSessions': 'Step 2 — Select sessions to add',
  'pages.projectsHub.createFolderButton': 'Create Folder',
  'pages.projectsHub.folderNameLabel': 'Folder name',
  'pages.projectsHub.subfolderNamePlaceholder': 'e.g. Due Diligence',
  'pages.projectsHub.collectionNamePlaceholder': 'e.g. M&A Due Diligence',
  'pages.projectsHub.optionalDescriptionPlaceholder': 'Optional description',
  'pages.projectsHub.optionalNotesPlaceholder': 'Optional notes',
  'pages.projectsHub.createCollectionModalTitle': 'Create Collection',
  'pages.projectsHub.collectionNameLabel': 'Collection name',
  'pages.projectsHub.editCollectionModalTitle': 'Edit • {name}',
  'pages.projectsHub.itemCountLabel': '{count, plural, one {# item} other {# items}}',
  'pages.projectsHub.fileCountLabel': '{count, plural, one {# file} other {# files}}',
  'pages.sideBySide.addAtLeastOneQuestion': 'Please add at least one question',
  'pages.sideBySide.addAtLeastOneQuestionBeforeSubmitting':
    'Please add at least one question before submitting.',
  'pages.sideBySide.addNewQuestionsPlaceholder': 'Add new questions (one per line)',
  'pages.sideBySide.addPlusButton': 'Add +',
  'pages.sideBySide.addQuestionsLabel': 'Add Questions',
  'pages.sideBySide.addToMattersButton': 'Add to Matters',
  'pages.sideBySide.authorFieldLabel': 'Author',
  'pages.sideBySide.authorLabel': 'Author: ',
  'pages.sideBySide.categoryLabel': 'Category',
  'pages.sideBySide.cellDetails.answer': 'Answer',
  'pages.sideBySide.cellDetails.verified': 'Verified',
  'pages.sideBySide.cellDetails.verify': 'Verify',
  'pages.sideBySide.cellMarkedUnverified': 'Cell marked as unverified',
  'pages.sideBySide.cellMarkedVerified': 'Cell marked as verified',
  'pages.sideBySide.cellUpdatedSuccess': 'Cell updated successfully',
  'pages.sideBySide.changesUndone': 'Changes undone',
  'pages.sideBySide.clickOrDragToUpload': 'Click or drag to upload',
  'pages.sideBySide.cloneButton': 'Clone',
  'pages.sideBySide.cloneModeLabel': 'Clone',
  'pages.sideBySide.clonedNamePrefix': 'CLONED - {name}',
  'pages.sideBySide.columnEditModal.columnAddedSuccess':
    'New column added. The matrix will refresh shortly.',
  'pages.sideBySide.columnEditModal.columnUpdateStartedSuccess':
    'Column update started. The column will refresh shortly.',
  'pages.sideBySide.columnEditModal.enterPromptWarning': 'Please enter a prompt.',
  'pages.sideBySide.columnEditModal.promptLabel': 'Prompt',
  'pages.sideBySide.columnEditModal.promptPlaceholder':
    'Describe the prompt/system instruction for this column',
  'pages.sideBySide.columnEditModal.title': 'Modify Column',
  'pages.sideBySide.columnEditModal.updateColumnFailed': 'Failed to update column',
  'pages.sideBySide.createCustomQuestionListDescription':
    'Create a custom Side by Side question list for this session',
  'pages.sideBySide.createModeLabel': 'Create',
  'pages.sideBySide.createQuestionListButton': 'Create Question List',
  'pages.sideBySide.createdByLabel': 'Created by: ',
  'pages.sideBySide.createdByYou': 'You',
  'pages.sideBySide.customInstructionOptional': '2. Custom Instruction (optional)',
  'pages.sideBySide.deleteQuestionListConfirm':
    'Are you sure you want to delete this question list?',
  'pages.sideBySide.dragHereToUpload': 'Drag here to upload',
  'pages.sideBySide.emailButton': 'Email',
  'pages.sideBySide.exitButton': 'Exit',
  'pages.sideBySide.exitModeButton': 'Exit {mode}',
  'pages.sideBySide.fileCount': '{count} File(s)',
  'pages.sideBySide.firmOption': 'Firm',
  'pages.sideBySide.firmWideOption': 'Firm-wide',
  'pages.sideBySide.fromDocumentOption': 'From Document',
  'pages.sideBySide.groupOption': 'Group',
  'pages.sideBySide.leadRowHeader': 'Paragraphs of Source Document',
  'pages.sideBySide.manualCraftOption': 'Manual Craft',
  'pages.sideBySide.modifyButton': 'Modify',
  'pages.sideBySide.modifyModeLabel': 'Modify',
  'pages.sideBySide.newCategoryPlaceholder': 'New category',
  'pages.sideBySide.newQuestionListButtonLabel': 'New Side by Side Question List',
  'pages.sideBySide.newQuestionListDefaultName': 'New Side by Side Question List',
  'pages.sideBySide.noNotesAvailable': 'No notes available.',
  'pages.sideBySide.noPurposeAvailable': 'No purpose available.',
  'pages.sideBySide.noSystemPromptConfigured': 'No system prompt configured.',
  'pages.sideBySide.notesFieldLabel': 'Notes',
  'pages.sideBySide.notesLabel': 'Notes: ',
  'pages.sideBySide.pendingApprovalTag': 'Pending Approval',
  'pages.sideBySide.pollingTimeoutWarning':
    'Polling timeout. The side by side may still be processing.',
  'pages.sideBySide.processing': 'Processing',
  'pages.sideBySide.processingStopped': 'Processing stopped.',
  'pages.sideBySide.publicOption': 'Public',
  'pages.sideBySide.publishButton': 'Publish',
  'pages.sideBySide.publishQuestionListFailed': 'Failed to publish question list',
  'pages.sideBySide.publishStatusLabel': 'Publish Status',
  'pages.sideBySide.publishToLabel': 'Publish to:',
  'pages.sideBySide.publishedToAccess': 'Published to {access}',
  'pages.sideBySide.publishedToGroupSuccess': 'Question list published to group',
  'pages.sideBySide.publishedToPrivateGroups': 'Question list published to private groups',
  'pages.sideBySide.publisherLabel': 'Publisher: ',
  'pages.sideBySide.purposeFieldLabel': 'Purpose',
  'pages.sideBySide.purposeLabel': 'Purpose: ',
  'pages.sideBySide.questionListClonedSuccess': 'Question list cloned successfully',
  'pages.sideBySide.questionListCreatedSuccess': 'Question list created successfully',
  'pages.sideBySide.questionListDeletedSuccess': 'Question list deleted successfully',
  'pages.sideBySide.questionListNamePlaceholder': 'Side-by-side Question List Name',
  'pages.sideBySide.questionListUpdatedSuccess': 'Question list updated successfully',
  'pages.sideBySide.questionsListLabel': 'Questions List',
  'pages.sideBySide.quickQuestionsDescription':
    'Generate structured side by side of one or more documents based on a set of ad-hoc questions',
  'pages.sideBySide.quickQuestionsTitle': 'Quick Questions',
  'pages.sideBySide.rejectedTag': 'Rejected',
  'pages.sideBySide.restoreConfigurationFailed':
    'Failed to restore configuration. Please try again.',
  'pages.sideBySide.reuseButton': 'Re-use',
  'pages.sideBySide.reviewTemplateQuestionsDescription': 'Review questions for this template',
  'pages.sideBySide.saveChangesButton': 'Save Changes',
  'pages.sideBySide.selectDocumentDescription':
    'Select the document you wish to perform a Side by Side on',
  'pages.sideBySide.selectGroupsPlaceholder': 'Select groups',
  'pages.sideBySide.selectGroupsToShareDescription': 'Select one or more groups to share with:',
  'pages.sideBySide.selectionDescription':
    'Generate structured side by side of one or more documents based on your Question Lists',
  'pages.sideBySide.selectionFeatureName': 'side by side',
  'pages.sideBySide.selectionTitle': 'Side-by-side',
  'pages.sideBySide.sentForApprovalSuccess': 'Question list sent for approval',
  'pages.sideBySide.showQuestionsButton': 'Show Questions',
  'pages.sideBySide.startGenerateReview': 'Start generate review',
  'pages.sideBySide.startNewSideBySideButton': 'Start a new Side-by-Side',
  'pages.sideBySide.stayButton': 'Stay',
  'pages.sideBySide.submitFailed': 'Failed to submit side-by-side',
  'pages.sideBySide.systemPromptLabel': 'System Prompt',
  'pages.sideBySide.tabs.prompts': 'Prompts',
  'pages.sideBySide.tabs.questionList': 'Question List',
  'pages.sideBySide.tabs.selectDocuments': 'Select Documents',
  'pages.sideBySide.targetAudiencePlaceholder': 'name of client or target audience',
  'pages.sideBySide.teamsButton': 'Teams',
  'pages.sideBySide.templateSystemPromptLabel': 'Template System Prompt',
  'pages.sideBySide.tour.noHistorySessions':
    'No side-by-side sessions available in history. Please create one first to see this step.',
  'pages.sideBySide.tour.step1.description':
    'Start by selecting a question list from the available categories. Click on any question list card to proceed.',
  'pages.sideBySide.tour.step1.title': 'Choose a Question List',
  'pages.sideBySide.tour.step2.description':
    'Enter the target audience or client name, then select the document you want to compare side by side.',
  'pages.sideBySide.tour.step2.title': 'Fill Target Audience and Select a File',
  'pages.sideBySide.tour.step3.description':
    'Review the system prompt and questions list here. Switch to the history panel to see previous sessions.',
  'pages.sideBySide.tour.step3.title': 'View System Prompt and Questions',
  'pages.sideBySide.tour.step4.description':
    'Once you submit, the side-by-side results will appear in a table. Click a cell to view details.',
  'pages.sideBySide.tour.step4.title': 'View Side-by-Side Results',
  'pages.sideBySide.typeHerePlaceholder': 'Type here...',
  'pages.sideBySide.undoChangesButton': 'Undo Changes',
  'pages.sideBySide.unsavedChangesWillBeLost': 'Any unsaved changes will be lost.',
  'pages.sideBySide.untitled': '(Untitled)',
  'pages.sideBySide.updateCellFailed': 'Failed to update cell',
  'pages.sideBySide.updateCellVerificationFailed': 'Failed to update cell verification',
  'pages.sideBySide.updateFailed': 'Failed to update',
  'pages.sideBySide.uploadDocumentFailed': 'Failed to upload document',
  'pages.sideBySide.whatsNewDescription':
    'Introduced several new features to enhance your document side by side process.',
  'pages.sideBySide.whoIsItForQuestion': '1. Who is it for?',
};
